import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import Legend from '../../../../components/Accessibility/Legend/Legend';
import Button from '../../../../UI/Button/Button';
import {showOverlay} from '../../../actions/overlay-actions';
import authorizeKlarna from '../../../actions/paymentActions/klarnaActions/authorizeKlarna';
import {setKlarnaCustomerDetails} from '../../../actions/paymentActions/klarnaActions/klarna-actions';
import {isValidEmail} from '../../../form/field-validation/valid-email';
import FieldContainer2 from '../../../form/FieldContainer2';
import Translation from '../../../lang/Translation';
import page from '../../../page/page';
import getDeliveryAddress from '../../../selectors/PlaceOrderSelectors/getDeliveryAddress';
import {
  getPlaceOrderDeliveryAddressOnPaymentResolution
} from '../../../selectors/PlaceOrderSelectors/PlaceOrderPropertiesSelectors';
import {isGuest} from '../../../selectors/selectors';
import Track from '../../../utils/tracking';
import V2Components from '../../../v2-components';
import {klarnaFieldsWithEmail, klarnaFieldsWithoutEmail} from './KlarnaFormFields';
import KlarnaFormFieldSet from './KlarnaFormFieldSet';

export class KlarnaForm extends Component {
  constructor(props) {
    super(props);
    
    this.validate = this.validate.bind(this);
    this.processErrorFieldName = this.processErrorFieldName.bind(this);
    this.setKlarnaCustomerDetailsHandler = this.setKlarnaCustomerDetailsHandler.bind(this);
    this.continuePayment = this.continuePayment.bind(this);
  }
  
  componentDidMount() {
    this.props.setKlarnaCustomerDetails('email', this.props.email);
    try {
      this.props.setKlarnaCustomerDetails('firstName', this.props.addressee?.split(' ')[0] || '');
      this.props.setKlarnaCustomerDetails('lastName', this.props.addressee?.split(' ').slice(1).join(' ') || '');
    } catch (e) {
      Track.track(`Klarna - Unable to prepopulate first and last name ${e}`);
    }
  }
  
  setKlarnaCustomerDetailsHandler(fieldName, fieldValue) {
    this.props.setKlarnaCustomerDetails(fieldName, fieldValue);
  }
  
  continuePayment() {
    if (this.validate().isValid) {
      this.props.authorizeKlarna(this.props.klarnaSDKFormat);
      this.props.showOverlay('order_processing');
    }
  }
  
  processErrorFieldName(errors) {
    return errors.map(error => ({
      fieldName: `klarna.${error.fieldName}`,
      errorCode: error.errorCode,
    }));
  }
  
  validate() {
    const containerValidationResult = this.fieldContainer.validate();
    return {
      isValid: containerValidationResult.isValid,
      errors: (containerValidationResult.isValid) ? undefined : this.processErrorFieldName(containerValidationResult.errors),
    };
  }
  
  render() {
    V2Components.register('klarnaForm', this);
    return (
      <fieldset className="KlarnaForm">
        <Legend hidden>
          <Translation>checkout.payment.method.klarna.name</Translation>
        </Legend>
        <FieldContainer2 key={3} fieldUpdateDispatcher={this.setKlarnaCustomerDetailsHandler}>
          {(fieldContainer) => {
            this.fieldContainer = fieldContainer;
            return (
              <div className="KlarnaForm__form">
                <KlarnaFormFieldSet
                  klarnaCustomerDetails={this.props.klarnaCustomerDetails}
                  definedFields={this.props.email && isValidEmail(this.props.email) ? klarnaFieldsWithoutEmail : klarnaFieldsWithEmail}
                  fieldContainer={fieldContainer}
                />
              </div>
            );
          }}
        </FieldContainer2>
        <Button
          id="KlarnaForm__continueButton"
          data-test="KlarnaForm__continueButton"
          className="KlarnaForm__continueButton"
          fullWidth
          primary
          type="submit"
          onClick={this.continuePayment}
        >
          <Translation>btn.continue.text</Translation>
        </Button>
      </fieldset>
    );
  }
}

KlarnaForm.propTypes = {
  email: PropTypes.string.isRequired,
  klarnaCustomerDetails: PropTypes.object.isRequired,
  klarnaSDKFormat: PropTypes.string.isRequired,
  authorizeKlarna: PropTypes.func.isRequired,
  showOverlay: PropTypes.func.isRequired,
  setKlarnaCustomerDetails: PropTypes.func.isRequired,
  addressee: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const paymentOption = state.payment.paymentOptionName;
  const klarnaVariant = paymentOption.toLowerCase().replace('klarna_', '');
  let klarnaSDKFormat = '';
  
  if (paymentOption.toLowerCase() === 'klarna') {
    klarnaSDKFormat = 'klarna';
  } else {
    klarnaSDKFormat = klarnaVariant === 'slice' ? 'pay_over_time' : `pay_${klarnaVariant}`;
  }
  
  const addressee = !page.isOnPage('payment-resolution') ?
    getDeliveryAddress(state)?.addressee : getPlaceOrderDeliveryAddressOnPaymentResolution(state)?.addressee;
  
  return {
    email: isGuest(state) && state.email.emailAddress ? state.email.emailAddress : state.start.customer.email,
    klarnaCustomerDetails: state.klarna.klarnaCustomerDetails,
    klarnaSDKFormat,
    addressee,
  };
};

export default connect(
  mapStateToProps,
  {setKlarnaCustomerDetails, authorizeKlarna, showOverlay},
)(KlarnaForm);
